export const brazilianstates = [
	{
		abbrev: "AC",
		name: "Acre"
	},
	{
		abbrev: "AL",
		name: "Alagoas"
	},
	{
		abbrev: "AM",
		name: "Amazonas"
	},
	{
		abbrev: "AP",
		name: "Amapá"
	},
	{
		abbrev: "BA",
		name: "Bahia"
	},
	{
		abbrev: "CE",
		name: "Ceará"
	},
	{
		abbrev: "DF",
		name: "Distrito Federal"
	},
	{
		abbrev: "ES",
		name: "Espírito Santo"
	},
	{
		abbrev: "GO",
		name: "Goiás"
	},
	{
		abbrev: "MA",
		name: "Maranhão"
	},
	{
		abbrev: "MG",
		name: "Minas Gerais"
	},
	{
		abbrev: "MS",
		name: "Mato Grosso do Sul"
	},
	{
		abbrev: "MT",
		name: "Mato Grosso"
	},
	{
		abbrev: "PA",
		name: "Pará"
	},
	{
		abbrev: "PB",
		name: "Paraíba"
	},
	{
		abbrev: "PE",
		name: "Pernambuco"
	},
	{
		abbrev: "PI",
		name: "Piauí"
	},
	{
		abbrev: "PR",
		name: "Paraná"
	},
	{
		abbrev: "RJ",
		name: "Rio de Janeiro"
	},
	{
		abbrev: "RN",
		name: "Rio Grande do Norte"
	},
	{
		abbrev: "RO",
		name: "Rondônia"
	},
	{
		abbrev: "RR",
		name: "Roraima"
	},
	{
		abbrev: "RS",
		name: "Rio Grande do Sul"
	},
	{
		abbrev: "SC",
		name: "Santa Catarina"
	},
	{
		abbrev: "SE",
		name: "Sergipe"
	},
	{
		abbrev: "SP",
		name: "São Paulo"
	},
	{
		abbrev: "TO",
		name: "Tocantins"
	}
];
